// extracted by mini-css-extract-plugin
export default {"inputContainer":"my-documents_inputContainer__+ksSp","listContainer":"my-documents_listContainer__2xP5L"};